import React from 'react'
import { Card, colors, H2, Separator, Skeleton } from '@fs/zion-ui'
import { type GroupSummary } from '@fs/zion-tree-types'
import { type GedcomFile, type GedcomFileFailed } from '../../../services/groupTypes'
import ManageTreeList, { ManageTreeListSkeleton } from './ManageTreeList'
import UploadTreeButton from './UploadTreeButton'

type TableProps = {
  /** Names the table for screen readers. Defaults to `title`; pass it for a table that shows no heading. */
  caption?: string
  failedFiles?: GedcomFileFailed[]
  groups: GroupSummary[]
  isMobile: boolean
  processingFiles?: GedcomFile[]
  title?: string
  showUploadButton?: boolean
  isFamilyGroupTree?: boolean
}

function ManageTreesTable({
  caption,
  failedFiles,
  groups,
  isMobile,
  processingFiles,
  title,
  showUploadButton,
  isFamilyGroupTree,
}: TableProps): JSX.Element {
  return (
    <Card margins="xs" edges="border" backgroundColor={colors.gray00}>
      {title && (
        <>
          <H2 size="H5">{title}</H2>
          <Separator size="xs" />
        </>
      )}
      <ManageTreeList
        caption={caption ?? title}
        processingFiles={processingFiles}
        groups={groups}
        failedFiles={failedFiles}
        isMobile={isMobile}
        isFamilyGroupTree={isFamilyGroupTree}
        showCombinedDesign
      />
      {/* eslint-disable-next-line test-selectors/button -- NA */}
      {showUploadButton && <UploadTreeButton emphasis="medium" />}
    </Card>
  )
}

export default ManageTreesTable

export function ManageTreesTableSkeleton({ isMobile }: { isMobile: boolean }): JSX.Element {
  return (
    <Card margins="xs" edges="border" backgroundColor={colors.gray00}>
      <ManageTreeListSkeleton isMobile={isMobile} showCombinedDesign />
      <Separator size="sm" />
      {/* eslint-disable-next-line test-selectors/button -- N/A */}
      <Skeleton.Button minWidth={150} />
    </Card>
  )
}
